import React from 'react';
import PropTypes from 'prop-types';

import { BulletedList } from 'components/listing';
import { Modal, ModalSize } from 'components/notifications';

import './BulkImportValidValuesModal.css';

const defaultArray = [];
const defaultFunction = () => { };

// The "show me everything" surface for a Lookup field's valid values, opened from the import
// fields reference table on the wizard's first step: every value the account currently accepts,
// one per line, in API order with no cap. The dialog grows with the list up to a capped height,
// beyond which the list scrolls beneath the heading rather than the dialog growing further.
export function BulkImportValidValuesModal(
    {
        showModal = false,
        friendlyName = "",
        values = defaultArray,
        onClose = defaultFunction
    }
) {
    return (
        <Modal
            isOpen={showModal}
            onClose={onClose}
            title={friendlyName}
            size={ModalSize.SMALL}
            updateStateOnClose={false}
            className="bulk-import-valid-values-modal"
        >
            <p className="valid-values-heading">Valid values:</p>
            <BulletedList
                listItems={values}
                loading={false}
            />
        </Modal>
    );
}

BulkImportValidValuesModal.propTypes = {
    showModal: PropTypes.bool,
    friendlyName: PropTypes.string,
    values: PropTypes.arrayOf(PropTypes.string),
    onClose: PropTypes.func,
};
